// This exports a Vue plugin and vanilla fetch functions

const fetcher = async (method, url, body) => {
  try {
    let opts = {
      method: method,
      headers: {
        Accept: 'application/json',
        'X-CSRF-Token': `${window.CSRF_TOKEN}`,
      },
    };
    if (body) {
      if (body instanceof FormData) {
        opts.body = body;
      } else {
        opts.body = JSON.stringify(body);
        opts.headers['Content-Type'] = 'application/json';
      }
    }
    const request = await fetch(url, opts);
    if (!request.ok) {
      const text = await request.text();
      try {
        return JSON.parse(text);
      } catch {
        return { errors: `Server error (${request.status})` };
      }
    }
    if (request.status === 204) return {};
    const text = await request.text();
    return text ? JSON.parse(text) : {};
  } catch (error) {
    return { errors: error.message };
  }
};

const fetchHtml = async (url) => {
  try {
    let opts = {
      method: 'GET',
      headers: {
        Accept: 'text/html',
        'Content-Type': 'text/html',
        'X-CSRF-Token': `${window.CSRF_TOKEN}`,
      },
    };
    const request = await fetch(url, opts);
    return await request.text();
  } catch (error) {
    return { errors: error.message };
  }
};

const $GET_HTML = (url) => {
  return fetchHtml(url);
};

const $GET = (url) => {
  return fetcher('GET', url);
};
const $POST = (url, body) => {
  return fetcher('POST', url, body);
};
const $PATCH = (url, body) => {
  return fetcher('PATCH', url, body);
};
const $DELETE = (url, body) => {
  return fetcher('DELETE', url, body);
};

const VueFetch = {
  install(app) {
    app.config.globalProperties.$GET = (url, params) => {
      if (params) {
        const urlWithParams = `${url}?${new URLSearchParams(
          params,
        ).toString()}`;
        return $GET(urlWithParams);
      }
      return $GET(url);
    };
    app.config.globalProperties.$POST = (url, body) => {
      return $POST(url, body);
    };
    app.config.globalProperties.$PATCH = (url, body) => {
      return $PATCH(url, body);
    };
    app.config.globalProperties.$DELETE = (url, body) => {
      return $DELETE(url, body);
    };
  },
};

export { $GET_HTML, $GET, $POST, $PATCH, $DELETE, VueFetch };
